import React from "react";
import PropTypes from "prop-types";
import Card from "~components/atoms/card/card";
import ModalWrapper from "../components/modal_wrapper/modal_wrapper";
import { modalInnerStyle } from "./modal_card.module.scss";

function ModalCard({ children, isModalActive, callbackToCloseModal }) {
  return (
    <ModalWrapper
      extraSmall
      {...{ children, isModalActive, callbackToCloseModal }}
    >
      <Card isFullWidth>
        <div className={modalInnerStyle}>{children}</div>
      </Card>
    </ModalWrapper>
  );
}

ModalCard.propTypes = {
  children: PropTypes.node,
  isModalActive: PropTypes.bool,
  callbackToCloseModal: PropTypes.func,
};

ModalCard.defaultProps = {
  children: null,
  isModalActive: false,
  callbackToCloseModal: null,
};

export default ModalCard;
